export const primaryColor = '#5AC6CC';
export const primaryColor900 = '#1C939E';
export const primaryColor200 = '#F0FFFD';
export const colorBgBaseDark = '#142E4D';
export const colorBgBaseLight = '#FFF';
export const colorTextBaseDark = '#FFF';
export const colorTextBaseLight = '#000';
export const layoutDarkColor = '#0F273F';
export const baseColor900 = '#222222';
export const baseColor800 = '#383838';
export const baseColor700 = '#777777';
export const baseColor600 = '#6F6F6F';
export const baseColor400 = '#D9D9D9';
export const baseColor300 = '#F0F0F0';
export const baseColor200 = '#F5F5F5';
export const baseColor150 = '#F8F8F8';
export const baseColor100 = '#FFF';
export const errorColor = '#F44336';
// AA-compliant error red for text on light backgrounds: #F44336 (and antd's
// default #ff4d4f) fall below the 4.5:1 contrast ratio, so error text fails
// WCAG AA. #C62828 keeps the same red hue while reaching ~5:1 on white/#ededed.
export const errorColor700 = '#C62828';
export const errorColor400 = 'rgba(244, 67, 54, 0.3)';
export const errorColor200 = 'rgba(244, 67, 54, 0.1)';
export const errorColor100 = 'rgba(255, 120, 117, 1)';
export const alertColor = '#FFA000';
// AA-compliant warning colour for text and icons on light backgrounds: #FFA000 sits at ~2:1 on
// white, so warning copy fails WCAG AA. Same value the preferences cards already settled on.
export const alertColor700 = '#684F00';
export const successColor = '#00C853';
export const successColor400 = 'rgba(0, 200, 83, 0.3)';
export const successColor200 = 'rgba(0, 200, 83, 0.1)';
export const tertiaryColor700 = '#1FAD87';
// Secondary/description text. 0.55 alpha blends to ~#7d7d7d, which fails WCAG
// AA (≈3.8:1) on the off-white surfaces antd uses (e.g. auth modal). 0.65 lands
// at ~5:1 while staying clearly "muted".
export const colorTextDescription = 'rgba(0, 0, 0, 0.65)';
export const colorBorder = '#50505D';

export const secondaryColor = '#00289F';
export const secondaryColor50 = '#f3f6ff';
export const colorFillQuaternary = 'rgba(0, 81, 202, 0.02)';
export const sideBarGradient = `linear-gradient(145deg, #0b023a, #0b023a, #0e3499, #4DFE95)`;
export const logoGradient = `linear-gradient(160deg, #0b023a, #0b023a, #0e3499, #4DFE95)`;
// Full-page background for the login / landing screens (green glow bottom-right → dark navy top-left)
export const loginGradient = `linear-gradient(-22.37deg, #4DFE95 0%, #18A2C1 13.36%, #12527E 26.6%, #0B023A 39.71%)`;
// Scrim painted behind the footer when it sits on `loginGradient`. The gradient's
// bright teal/green end lands under the footer on narrow viewports, where light
// footer text drops to ~1.9:1 contrast; this darkens the band back past WCAG AA.
export const loginFooterScrim = `linear-gradient(to bottom, rgba(11, 2, 58, 0.55) 0%, rgba(11, 2, 58, 0.92) 100%)`;
export const colorSuccessBgHover = '#d9f7be';
export const colorSuccessText = '#135200';

// Color palette from Figma design system (Ant Design colors)
// Green
export const green200 = '#d9f7be';
export const green500 = '#52c41a';
export const green800 = '#237804';

// GeekBlue
export const geekBlue200 = '#d6e4ff';
export const geekBlue800 = '#10239e';

// Orange
export const orange200 = '#ffe7ba';
export const orange500 = '#fa8c16';
export const orange800 = '#ad4e00';

// Gray
export const gray300 = '#f0f0f0';
export const gray500 = '#8c8c8c';
export const grayText = 'rgba(0,0,0,0.88)';

// Red
export const red200 = '#ffccc7';
export const red500 = '#f5222d';
export const red800 = '#a8071a';

// Cyan
export const cyan200 = '#cbf1f1';
export const cyan900 = '#177c85';

// Purple
export const purple200 = '#efdbff';
export const purple800 = '#391085';

// Magenta
export const magenta100 = '#fff0f6';
export const magenta700 = '#c41d7f';

// Gold
export const gold100 = '#fff7e6';
export const gold700 = '#d48806';

// Lime
export const lime100 = '#e6fffb';
export const lime700 = '#389e0d';

// Blue
export const blue200 = '#e6f4ff';
export const blue500 = '#1677ff';
export const blue800 = '#0958d9';
